import { NgStyle } from '@angular/common';
import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ChatbotConfig } from '@shared/index';
import { getContrastColorSafe } from '@shared-angular';
import { BotService } from '../../../services/bot.service';
import { EndBotOptions, EndbotService } from '@shared-angular/services/endbot.service';

@Component({
    imports: [NgStyle],
    templateUrl: './bot-end.component.html',
    styleUrl: './bot-end.component.scss'
})
export class BotEndComponent {

  protected getContrastColor = getContrastColorSafe;

  public botConfig!: ChatbotConfig;
  constructor(public endBotService: EndbotService, route: ActivatedRoute, public botService: BotService) {
    route.data.subscribe(data => {
      this.botConfig = data['botConfig'] as ChatbotConfig;
    });
    const opts = route.snapshot.queryParams as EndBotOptions;
    this.endBotService.endPageComponentLoaded(opts);
  }

  public getColorFromConfig(background: boolean = false): string {
    return this.botService.getColorFromConfig(this.botConfig, background);
  }
}
